import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, Divider, IconButton, Box, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactNode } from "react";

export interface NavItem {
    label: string;
    icon: ReactNode;
    onClick: () => void;
}

interface NavigationDrawerProps {
    open: boolean;
    onClose: () => void;
    items: NavItem[];
}

const NavigationDrawer: React.FC<NavigationDrawerProps> = ({ open, onClose, items }) => {
    const theme = useTheme();

    return (
        <Drawer
            variant="temporary"
            anchor="left"
            open={open}
            onClose={onClose}
            ModalProps={{ keepMounted: true }}
            sx={{
                "& .MuiDrawer-paper": {
                    width: 240,
                    backgroundColor: theme.palette.sidebar.main,
                    color: theme.palette.common.white,
                    boxSizing: "border-box",
                },
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{ color: theme.palette.common.white, "&:focus": { outline: "none" } }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>

            <Divider sx={{ borderColor: "rgba(255,255,255,0.12)" }} />

            <List disablePadding>
                {items.map(({ label, icon, onClick }) => (
                    <ListItemButton
                        key={label}
                        onClick={() => { onClick(); onClose(); }}
                        sx={{
                            py: 1.5,
                            "&:hover": { backgroundColor: "rgba(255,255,255,0.08)" },
                            "&:focus": { outline: "none" },
                        }}
                    >
                        <ListItemIcon sx={{ color: theme.palette.common.white, minWidth: 36 }}>
                            {icon}
                        </ListItemIcon>
                        <ListItemText
                            primary={label}
                            sx={{ color: theme.palette.common.white }}
                            slotProps={{
                                primary: {
                                    fontFamily: theme.typography.heading?.fontFamily,
                                    fontWeight: theme.typography.fontWeightMedium,
                                    fontSize: "0.875rem",
                                },
                            }}
                        />
                    </ListItemButton>
                ))}
            </List>
        </Drawer>
    );
};

export default NavigationDrawer;
